import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  radii,
  spacing,
} from "@softmax/design-system/tokens.stylex";
export const postStyles = stylex.create({
  plainText: { whiteSpace: "pre-wrap", overflowWrap: "anywhere" },
  renderFrame: {
    display: "block",
    width: "100%",
    minHeight: 480,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: colors.border,
    borderRadius: radii.small,
    backgroundColor: colors.background,
  },
  article: {
    backgroundColor: colors.background,
    display: "grid",
    gridTemplateColumns: "44px minmax(0, 1fr)",
    gap: spacing.space16,
    marginTop: spacing.space16,
  },
  voteStack: { display: "flex", flexDirection: "column", alignItems: "center" },
  shareContent: { backgroundColor: colors.background },
  articleTitle: {
    margin: 0,
    fontSize: {
      default: fontSizes.pageTitle,
      "@media (min-width: 768px)": fontSizes.pageTitleWide,
    },
    fontWeight: 600,
    lineHeight: 1.15,
    overflowWrap: "anywhere",
  },
  articleBody: { marginTop: spacing.space24, maxWidth: "68ch", minWidth: 0 },
});
